import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import MetaTags from 'react-meta-tags';

import LoginStyles from './Login.css';
import FormGroupStyles from './components/FormGroup.css';

import WarningMessage from './components/WarningMessage';

import utilities from "./components/Utilities";
let Utilities = new utilities();

class Login extends Component {

    constructor(props) {

        super(props);

        this.state = {
            email: "",
            password: "",
            loginStatusMsg: "",
            buttonEnabled: true,
            referrer: null
        };

    }

    disableButton = () => { this.setState({ buttonEnabled: false }) }
    enableButton = () => { this.setState({ buttonEnabled: true }) }

    componentDidMount() {
        document.title = window.globalVars.pageTitleBefore + "Login" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
        this.setState({
            referrer: document.referrer
        })
    }

    onInputChange = (e) => {

        let modifiedField = e.target.id;
        let modifiedFieldValue = e.target.value;

        let state = {...this.state};
        state[modifiedField] = modifiedFieldValue;

        this.setState(state);

    }

    login = (e) => {

        if (e.target.getAttribute("data-enabled") !== "true") {
            return;
        }

        this.disableButton();

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/login",
            data: {
                user: {
                    email: this.state.email,
                    password: this.state.password
                }
            },
            then: function(res) {

                if (res.data.success === false) {
                    this.setState({
                        loginStatusMsg: res.data.data
                    })
                    this.enableButton();
                } else {

                    window.globalVars.server.saveAuthenticationTokenToLocalStorage(res.data.user.token);

                    setTimeout(function() {

                        let cart = JSON.parse(localStorage.getItem("cart"));

                        if (Utilities.isENU(cart)) {
                            window.location.href = "/profile"
                        } else {
                            window.location.href = "/cart"
                        }

                    }, 400)

                }

            }.bind(this),
            catch: function(e) {

                this.setState({
                    loginStatusMsg: "Unexpected Error"
                })

                this.enableButton();

            }.bind(this)
        })

    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.login(e);
        }
    }

    render() {

        return (
            <div className="login">
                <MetaTags>
                    <meta name="robots" content="index" />
                    <meta name="googlebot" content="index" />
                </MetaTags>
                <div className="main-container">
                    <h1>Login</h1>
                    <div className="form">
                        <div className="form-group">
                            <label for="email">Email*</label>
                            <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.passwordAgain} type="email" name="email" id="email" placeholder="Email" />
                        </div>
                        <div className="form-group">
                            <label for="password">Password*</label>
                            <input data-enabled={this.state.buttonEnabled} onKeyPress={this.handleKeyPress} onChange={this.onInputChange} defaultValue={this.state.passwordAgain} type="password" name="password" id="password" placeholder="Password" />
                        </div>
                        <WarningMessage message={this.state.loginStatusMsg} />
                        <div className="options">
                            <div className="clearfix">
                                <Link className="restore-password-btn" to="restore/email">
                                    Forgot Password...
                                </Link>
                                <button data-enabled={this.state.buttonEnabled} className="login-btn" onClick={(e) => {this.login(e)}}>
                                    Login
                                </button>
                            </div>
                            <hr />
                            <div className="clearfix">
                                <p>
                                    Don't have an account?
                                </p>
                                <Link to="/register" className="register-btn">
                                    Register Now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js